/** 교육기관(파트너)명 — 대한병원협회 */
export const KHA_ORGANIZATION_TITLE = '대한병원협회';

/** public/ 정적 서명 이미지 (API 미제공 시 사용) */
export const KHA_ISSUER_SIGNATURE_PATH = '/assets/certificates/kha-issuer-signature.png';

/** public/ 파트너기관 로고 (서명 하단 표시) */
export const KHA_PARTNER_LOGO_PATH = '/kha-logo.png';

/** 파트너기관 로고 없을 때 사용하는 기본 로고 */
export const NEWBASE_CERTIFICATE_LOGO_PATH = '/assets/images/brand/newbase.png';

/** 이수증 푸터 medicrew 로고 (primary 배경용 흰색) */
export const MEDICREW_CERTIFICATE_FOOTER_LOGO_PATH = '/assets/images/brand/medicrew_logo-white.png';

/**
 * 교육기관별 발급기관 서명 이미지 URL.
 * API 필드가 없을 때 알려진 기관은 정적 asset을 반환한다.
 */
export function resolveCertificateIssuerSignatureImageUrl(
	educationInstitutionName: string | null | undefined
): string | null {
	const normalizedName = educationInstitutionName?.trim();
	if (!normalizedName) return null;
	if (normalizedName === KHA_ORGANIZATION_TITLE) {
		return KHA_ISSUER_SIGNATURE_PATH;
	}
	return null;
}

/**
 * 교육기관별 파트너기관 로고 URL (서명 이미지 하단).
 * API 필드가 없을 때 알려진 기관은 정적 asset을 반환한다.
 */
export function resolveCertificatePartnerLogoImageUrl(
	educationInstitutionName: string | null | undefined
): string | null {
	const normalizedName = educationInstitutionName?.trim();
	if (!normalizedName) return null;
	if (normalizedName === KHA_ORGANIZATION_TITLE) {
		return KHA_PARTNER_LOGO_PATH;
	}
	return null;
}
